<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row>
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('Supppliers.PaymentTerms.List')"
            :contenttext="$t('Supppliers.PaymentTerms.TableHeaderContent')">
          </Headerlayout>
        </b-col>
      </b-row>
      <b-row class="py-3">
        <div v-if="windowWidth > 545">
          <SkeletonTableLoader :columns="headers" :loading="loading" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading1" eheader="Payment Terms" econtent="Payment Terms"
              eimg="/src/assets/Img/icons/paymentterms.svg" @createNew="IsAdd" />
            <div class="table-width-80">
              <Tableview v-if="items.length > 0" :value="items" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                :columns="headers" @row-click="RowClick" :globalFilterFields="globalFilterFields" :filters="filters"
                selectionMode="single" :totalRecords="rowsCount" :state="state" @page-change="onPageChange"
                :exceldownload="true">
                <template v-slot:Add>
                  <span class="add">
                    <AddButton @click="IsAdd()" :btnname="$t('btn.plusaddnew')" class="float-rights my-3"></AddButton>
                  </span>
                </template>
                <template v-slot:exceldownload>
                  <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                    PageName="Paymentterms Master" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                </template>
                <template v-slot:Status="{ data }">

                  <OrangeStatus name="InActive" v-if="data.IsActive == '0'" />
                  <GreenStatus name="Active" v-if="data.IsActive == '1'" />


                </template>
                <template v-slot:action="{ data }">
                  <span>

                    <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                      @click="toggle($event, data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
        </div>
        <div v-if="windowWidth <= 545">
          <MobileLoader v-if="loading" v-for="item in 5" />
          <div v-if="!loading">
            <MasterEmpty v-if="items.length === 0 && !loading1" eheader="Payment Terms" econtent="Payment Terms"
              eimg="/src/assets/Img/icons/paymentterms.svg" @createNew="IsAdd" />
            <MobileViewCardHeader>
              <template v-slot:mobilecard>
                <div class="mobile-card" v-for="item in items">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div>
                      <p class="light-name">{{ item.PaymentTermsCode }}</p>
                      <div class="d-flex align-items-center gap-2">
                        <p class="name">{{ item.NoofDays + " Days" }}</p>
                        <p class="small-name">
                          ({{ item.PercentageOfAdvance + "%" }})
                        </p>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                      <div>
                        <!-- <Badge v-if="item.IsActive == '0'" severity="warning">{{
            "InActive"
          }}</Badge>
                        <Badge v-if="item.IsActive == '1'" severity="success">{{
            "Active"
          }}</Badge> -->
                        <OrangeStatus name="InActive" v-if="item.IsActive == '0'" />
                        <GreenStatus name="Active" v-if="item.IsActive == '1'" />
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                  </div>
                  <p class="light-name">{{ item.PaymentTermsDesc }}</p>
                </div>
              </template>
            </MobileViewCardHeader>

          </div>
        </div>
        <PaymentCreation v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
          @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading1 = false"
          @loadershow="loading1 = true" :OperationID="ObjOperationId" :EntityId="EntityData.EntityId" />
      </b-row>
    </b-container>
  </div>

  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <ActivatedSuccessfully :visible="pop.activatepop" @ok="closetrigger()" />
  <InActivatedSuccessfully :visible="pop.inactivepop" @ok="closetrigger()" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="contentdel" @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <Mapping :visible="MappingPop.visible" @ok="closetrigger()" :content="MappingPop.content" />
  <Toast />

</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  h,
  computed,
  reactive,
  watch,
  onUnmounted,
} from "vue";
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";
import PaymentCreation from "../../../Masters/Supplier/PaymentTerms/PaymentTermsCreation.vue";
import PaymentTermsService from "../../../../../../modules/Inventory/Service/PaymentTermsService";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import ActivatedSuccessfully from "../../../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../../../components/FormComponents/InActivateSuccessfully.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    DeletedSuccessfully,
    DeleteConfirmationVue,
    BacktoPage,
    Headerlayout,
    PaymentCreation,
    Tableview,
    EditConfirmation,
    Mapping,
    Loader,
    MasterEmpty,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  setup() {
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const toast = useToast();
    const showDialog = ref(false);
    const dataEdit = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    const editItems = ref();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    let MappingPopup = ref(false);
    let loading1 = ref(false);
    let ContentName = ref("");
    const rowsCount = ref(0);
    const menu = ref();
    let objectdata = ref({});
    let InActivevisible = ref();
    let Editvisible = ref();
    let delId = 0;
    const items: any = ref([]);
    const loader = ref(false); //loading
    let Activevisible = ref();
    let Deletevisible = ref();
    let loading = ref(false);
    const MappingPop = ref({
      visible: false,
      content: "",
    });
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });
    function IsAdd() {
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function RowClick(event: any) {
      debugger;
      Editmodel.value = true;
      rowFocus.value = true;
      dataEdit.value = event.data;
    }

    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const contentdel = ref("");
    const pop = ref({
      activatepop: false,
      inactivepop: false,
    });
    function IsConfirmDel(data, Status) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        data.ActiveStatus = Status;
        dataEdit.value = data;
        Editmodel.value = false;
        if (Status == 1) {
          contentdel.value = t('confirmation.activecontent');
        } else if (Status == 2) {
          contentdel.value = t('confirmation.inactivecontent');
        } else {
          contentdel.value = t('confirmation.deletecontent');
        }
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
      pop.value.activatepop = false;
      pop.value.inactivepop = false;
      MappingPop.value.visible = false;
    }
    function closemapping() {
      MappingPopup.value = false;
      Deletemodel.value = false;
    }

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }


    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        Deletemodel.value == false &&
        showDialog.value == false
      ) {
        // IsEdit(dataEdit.value)
        Editmodel.value = true;
      } else if (
        event.altKey &&
        event.key == "n" &&
        Editmodel.value == false &&
        Deletemodel.value == false
      ) {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false &&
        Editmodel.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopup.value == true) {
        MappingPopup.value = false;
        Deletemodel.value = false;
      }
    }

    const filter = "";
    const headers = [
      {
        header: t('Supppliers.PaymentTerms.sno'),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t('Supppliers.PaymentTerms.Code'),
        field: "PaymentTermsCode",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t('Supppliers.PaymentTerms.noofdays'),
        field: "NoofDays",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('Supppliers.PaymentTerms.perofadvance'),
        field: "PercentageOfAdvance",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('Supppliers.PaymentTerms.Remarks'),
        field: "PaymentTermsDesc",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "largewidth",
        bodyclass: "text_overflow1",
      },
      {
        header: t('Supppliers.PaymentTerms.Status'),
        field: "ActiveStatus",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "Status",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    let ExportOption = ref("");
    let ExportList = ref([]);


    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;
        const response = await PaymentTermsService.getdata();
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.organizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", items.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const IsShow = async () => {
      loading.value = true;

      try {
        const response = await PaymentTermsService.getdata();
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;
            item.ActiveStatus = item.IsActive == 1 ? "Active" : "Inactive";
            return item;
          });


        items.value = response["result"];
        if (response["result"].length > 0) {
          rowsCount.value = response["result"].length;
        }
        loading.value = false;
        console.log(items.value);
      } catch (error) {
        loader.value = false;
        alert(error);
      }
    };

    //Edit Box
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }


    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      PaymentTermsCode: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      NoofDays: { value: null, matchMode: FilterMatchMode.IN, options: items },
      PercentageOfAdvance: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      PaymentTermsDesc: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      ActiveStatus: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });
    const globalFilterFields = ref(headers.map((col) => col.field));

    const onPageChange = (event: { page: number }) => {
      debugger;
      state.currentPage = event.page;
    };
    const IsDelete = async (data) => {
      Deletemodel.value = false;
      loading1.value = true;
      try {
        let response: any = "";
        if (data.ActiveStatus == 0) {
          response = await PaymentTermsService.deletedata(data.Id);
        } else {
          let status = data.ActiveStatus == 1 ? true : false;
          response = await PaymentTermsService.active(data.Id, status);
        }
        let message = response["ErrorInfo"].ErrorCode;
        loading1.value = false;
        if (response["result"] != "False" && message == null) {
          Deletemodel.value = false;
          MappingPop.value.content = response["result"];
          loading.value = false;

          MappingPop.value.visible = true;
        } else if (message == null) {
          if (data.ActiveStatus == 1) {
            pop.value.activatepop = true;
          } else if (data.ActiveStatus == 2) {
            pop.value.inactivepop = true;
          } else {
            deletepop.value = true;
          }
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading1.value = false;
        alert(error);
      }
    };

    const toggle = (event, data) => {
      debugger;
      console.log(event);
      objectdata.value = data;
      if (data.IsActive == 0) {
        InActivevisible.value = false;
        Activevisible.value = true;
        Editvisible.value = false;
      } else {
        InActivevisible.value = true;
        Activevisible.value = false;
        Editvisible.value = true;
      }

      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: Editvisible,
            command: async () => {
              IsConfirmEdit(objectdata.value);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(objectdata.value, 0);
            },
          },

          {
            label: "Active",
            icon: "editicon pi pi-check-circle",
            visible: Activevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 1);
            },
          },
          {
            label: "InActive",
            icon: "deleteicon pi pi-minus-circle",
            visible: InActivevisible,
            command: async () => {
              IsConfirmDel(objectdata.value, 2);
            },
          },
        ],
      },
    ]);

    return {
      ObjOperationId,
      contentdel,
      pop,
      MappingPop,
      toggle,
      menu,
      itemListed,
      ContentName,
      MappingPopup,
      closemapping,
      IsAdd,
      RowClick,
      Deletemodel,
      deletepop,
      closetrigger,
      IsShow,
      IsDelete,
      loader,
      headers,
      items,
      filter,
      filters,
      globalFilterFields,
      filteredColumns,
      loading,
      showDialog,
      IsConfirmEdit,
      IsConfirmDel,
      editItems,
      dataEdit,
      Editmodel,
      IsEdit,
      loading1,
      rowsCount,
      state,
      onPageChange,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
      EntityData
    };
  },
});
</script>
<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  margin-top: -7px;
}

.mobilecategorycode {
  font-size: 14px;
  margin-top: -7px;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
